<!-- <div
  class="get-in-touch transition"
  (click)="checkMobileNumber()"
  *ngIf="testPopup"
  data-toggle="modal"
  data-target="#autoload">
  get in touch
</div> -->

<div
  class="header-fixed sh-header-wrap transition"
  [class.sh-scrolled]="headerScrolled"
  [class.sh-mega-suppressed]="megaSuppressed"
>
  <!-- ===================== TOP RIBBON ===================== -->
  <div class="sh-topbar">
    <div class="sh-topbar-inner">
      <div class="sh-topbar-left">
        <a (click)="openPhoneNumber()" class="sh-phone cursor">
          <i class="ti ti-phone"></i> (0)2039808244
        </a>
        <a
          href="https://go.sehyog.co.uk/FreeDemoForm"
          class="sh-offer-chip"
          target="_blank"
        >
          <i class="ti ti-gift"></i> Book a Free Demo
        </a>
      </div>
      <ul class="sh-topbar-socials list list-inline">
        <li>
          <a href="{{ siteSetting?.social_telegram_url }}" target="_blank"
            ><i class="fa fa-paper-plane" aria-hidden="true"></i
          ></a>
        </li>
        <li>
          <a href="{{ siteSetting?.social_facebook_url }}" target="_blank"
            ><i class="fa fa-facebook" aria-hidden="true"></i
          ></a>
        </li>
        <li>
          <a href="{{ siteSetting?.social_twitter_url }}" target="_blank"
            ><i class="fa fa-twitter" aria-hidden="true"></i
          ></a>
        </li>
        <li>
          <a href="{{ siteSetting?.social_linkedin_url }}" target="_blank"
            ><i class="fa fa-linkedin" aria-hidden="true"></i
          ></a>
        </li>
      </ul>
    </div>
  </div>

  <!-- ===================== MAIN HEADER ===================== -->
  <header class="sh-header" [class.has-login]="isLoggedInUser">
    <div class="sh-header-inner">
      <a [routerLink]="['/']" class="sh-logo">
        <img
          src="assets/images/logo-w-aca.png"
          class="sh-logo-img transition"
          alt="Sehyog Academy"
        />
      </a>

      <!-- ---------- Desktop nav ---------- -->
      <nav class="sh-nav" (mouseleave)="resetMegaSuppression()">
        <div class="sh-nav-item">
          <a class="sh-nav-link" [routerLink]="['/']">Home</a>
        </div>

        <!-- 11+ mega menu (dynamic columns) -->
        <div class="sh-nav-item">
          <a class="sh-nav-link cursor"
            >11+ <i class="ti ti-chevron-down"></i
          ></a>
          <div class="sh-mega">
            <div
              class="sh-mega-cols"
              [class.sh-compact]="isCompact(elevenPlusColumns)"
            >
              <div
                class="sh-mega-col"
                *ngFor="let col of visibleColumns(elevenPlusColumns)"
              >
                <h4>{{ col.label }}</h4>

                <ng-container *ngFor="let link of col.links">
                  <!-- Angular internal route -->
                  <a
                    *ngIf="link.route"
                    class="sh-mega-link"
                    [routerLink]="link.route"
                    (click)="closeMegaMenu()"
                  >
                    <span class="ic">
                      <i class="ti" [ngClass]="link.icon"></i>
                    </span>

                    <span class="cp">
                      <span class="sh-lt">
                        <span class="sh-lt-text">{{ link.title }}</span>

                        <span
                          class="sh-badge"
                          [class.hot]="link.badgeHot"
                          *ngIf="link.badge"
                        >
                          {{ link.badge }}
                        </span>
                      </span>

                      <span class="dc" *ngIf="link.desc">
                        {{ link.desc }}
                      </span>
                    </span>
                  </a>

                  <!-- External URL -->
                  <a
                    *ngIf="!link.route && link.href"
                    class="sh-mega-link"
                    [href]="link.href"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="closeMegaMenu()"
                  >
                    <span class="ic">
                      <i class="ti" [ngClass]="link.icon"></i>
                    </span>

                    <span class="cp">
                      <span class="sh-lt">
                        <span class="sh-lt-text">{{ link.title }}</span>

                        <span
                          class="sh-badge"
                          [class.hot]="link.badgeHot"
                          *ngIf="link.badge"
                        >
                          {{ link.badge }}
                        </span>
                      </span>

                      <span class="dc" *ngIf="link.desc">
                        {{ link.desc }}
                      </span>
                    </span>
                  </a>
                </ng-container>
              </div>
            </div>
            <div class="sh-mega-cta">
              <i class="ti ti-calendar-event"></i>
              <h5>Book a Free 11+ Demo</h5>
              <p>
                See how our mocks, tutors and reports work — no cost, no
                commitment.
              </p>
              <a
                href="https://go.sehyog.co.uk/FreeDemoForm"
                class="sh-btn"
                (click)="closeMegaMenu()"
                >Book Free Demo <i class="ti ti-arrow-right"></i
              ></a>
            </div>
          </div>
        </div>

        <!-- GCSE mega menu (dynamic columns) -->
        <div class="sh-nav-item">
          <a class="sh-nav-link cursor"
            >GCSE <i class="ti ti-chevron-down"></i
          ></a>
          <div class="sh-mega">
            <div
              class="sh-mega-cols"
              [class.sh-compact]="isCompact(gcseColumns)"
            >
              <div
                class="sh-mega-col"
                *ngFor="let col of visibleColumns(gcseColumns)"
              >
                <h4>{{ col.label }}</h4>

                <ng-container *ngFor="let link of col.links">
                  <!-- Angular internal route -->
                  <a
                    *ngIf="link.route"
                    class="sh-mega-link"
                    [routerLink]="link.route"
                    (click)="closeMegaMenu()"
                  >
                    <span class="ic">
                      <i class="ti" [ngClass]="link.icon"></i>
                    </span>

                    <span class="cp">
                      <span class="sh-lt">
                        <span class="sh-lt-text">{{ link.title }}</span>

                        <span
                          class="sh-badge"
                          [class.hot]="link.badgeHot"
                          *ngIf="link.badge"
                        >
                          {{ link.badge }}
                        </span>
                      </span>

                      <span class="dc" *ngIf="link.desc">
                        {{ link.desc }}
                      </span>
                    </span>
                  </a>

                  <!-- External URL -->
                  <a
                    *ngIf="!link.route && link.href"
                    class="sh-mega-link"
                    [href]="link.href"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="closeMegaMenu()"
                  >
                    <span class="ic">
                      <i class="ti" [ngClass]="link.icon"></i>
                    </span>

                    <span class="cp">
                      <span class="sh-lt">
                        <span class="sh-lt-text">{{ link.title }}</span>

                        <span
                          class="sh-badge"
                          [class.hot]="link.badgeHot"
                          *ngIf="link.badge"
                        >
                          {{ link.badge }}
                        </span>
                      </span>

                      <span class="dc" *ngIf="link.desc">
                        {{ link.desc }}
                      </span>
                    </span>
                  </a>
                </ng-container>
              </div>
            </div>
            <div class="sh-mega-cta">
              <i class="ti ti-calendar-event"></i>
              <h5>Book a Free GCSE Demo</h5>
              <p>
                Watch a quick tour of how Sehyog helps students hit target
                grades.
              </p>
              <a
                href="https://go.sehyog.co.uk/FreeDemoForm"
                class="sh-btn"
                (click)="closeMegaMenu()"
                >Book Free Demo <i class="ti ti-arrow-right"></i
              ></a>
            </div>
          </div>
        </div>

        <!-- Tuition = A-Level + Tuition combined -->
        <div class="sh-nav-item">
          <a class="sh-nav-link cursor"
            >Tuition <i class="ti ti-chevron-down"></i
          ></a>
          <div class="sh-mega">
            <div class="sh-mega-cols">
              <div
                class="sh-mega-col"
                *ngFor="let col of visibleColumns(tuitionColumns)"
              >
                <h4>{{ col.label }}</h4>
                <ng-container *ngFor="let link of col.links">

  <!-- Internal Angular route -->
  <a
    *ngIf="link.route"
    class="sh-mega-link"
    [routerLink]="link.route"
    (click)="closeMegaMenu()">

    <span class="ic">
      <i class="ti" [ngClass]="link.icon"></i>
    </span>

    <span class="cp">
      <span class="sh-lt">
        <span class="sh-lt-text">{{ link.title }}</span>
      </span>

      <span class="dc" *ngIf="link.desc">
        {{ link.desc }}
      </span>
    </span>

  </a>

  <!-- External href -->
  <a
    *ngIf="!link.route && link.href"
    class="sh-mega-link"
    [href]="link.href"
    target="_blank"
    rel="noopener noreferrer"
    (click)="closeMegaMenu()">

    <span class="ic">
      <i class="ti" [ngClass]="link.icon"></i>
    </span>

    <span class="cp">
      <span class="sh-lt">
        <span class="sh-lt-text">{{ link.title }}</span>
      </span>

      <span class="dc" *ngIf="link.desc">
        {{ link.desc }}
      </span>
    </span>

  </a>

</ng-container>


              </div>
            </div>
            <div class="sh-mega-cta">
              <i class="ti ti-calendar-event"></i>
              <h5>Find the Right Level</h5>
              <p>
                Not sure which programme fits? Book a free consultation and
                we'll match your child to the right level.
              </p>
              <a
                href="https://go.sehyog.co.uk/FreeDemoForm"
                class="sh-btn"
                (click)="closeMegaMenu()"
                >Book Consultation <i class="ti ti-arrow-right"></i
              ></a>
            </div>
          </div>
        </div>

        <!-- Uni. Program — simple dropdown, no CTA panel -->
        <div class="sh-nav-item sh-nav-item-anchored">
          <a class="sh-nav-link cursor"
            >Uni. Program <i class="ti ti-chevron-down"></i
          ></a>
          <div class="sh-mega sh-mega-sml">
            <div class="sh-mega-cols">
              <div class="sh-mega-col">
                <a
                  class="sh-mega-link"
                  *ngFor="let link of uniProgramLinks"
                  [routerLink]="link.route"
                  [href]="link.href"
                  (click)="closeMegaMenu()"
                >
                  <span class="ic"
                    ><i class="ti" [ngClass]="link.icon"></i
                  ></span>
                  <span class="cp"
                    ><span class="sh-lt"
                      ><span class="sh-lt-text">{{ link.title }}</span></span
                    ></span
                  >
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="sh-nav-item">
          <a class="sh-nav-link" [routerLink]="['/blogs']">Blogs</a>
        </div>

        <!-- About Us mega menu -->
        <div class="sh-nav-item">
          <a class="sh-nav-link cursor"
            >About Us <i class="ti ti-chevron-down"></i
          ></a>
          <div class="sh-mega">
            <div
              class="sh-mega-cols"
              [class.sh-compact]="isCompact(aboutUsColumns)"
            >
              <div
                class="sh-mega-col"
                *ngFor="let col of visibleColumns(aboutUsColumns)"
              >
                <h4>{{ col.label }}</h4>
                <a
                  class="sh-mega-link"
                  *ngFor="let link of col.links"
                  [routerLink]="link.route"
                  [href]="link.href"
                  (click)="closeMegaMenu()"
                >
                  <span class="ic"
                    ><i class="ti" [ngClass]="link.icon"></i
                  ></span>
                  <span class="cp"
                    ><span class="sh-lt"
                      ><span class="sh-lt-text">{{ link.title }}</span></span
                    ></span
                  >
                </a>
              </div>
            </div>
            <div class="sh-mega-cta">
              <i class="ti ti-building-store"></i>
              <h5>Bring Sehyog to Your City</h5>
              <p>
                Explore franchise opportunities and partner with our academy.
              </p>
              <a
                [routerLink]="['/request-for-franchise']"
                class="sh-btn"
                (click)="closeMegaMenu()"
                >Request Franchise <i class="ti ti-arrow-right"></i
              ></a>
            </div>
          </div>
        </div>

        <div class="sh-nav-item">
          <a class="sh-nav-link" [routerLink]="['/contact-us']">Contact us</a>
        </div>

        <div class="sh-nav-item" *ngIf="isLoggedInUser">
          <a [routerLink]="['/basket']" class="sh-nav-link">
            <i class="fa fa-shopping-basket" aria-hidden="true"></i>
            Basket ( <span class="header-basket-count">0</span> )
          </a>
        </div>
      </nav>

      <!-- ---------- Header right side: auth + burger ---------- -->
      <div class="sh-header-actions">
        <ul class="sh-acc-drop" *ngIf="isLoggedInUser; else sh_guestActions">
          <li class="dropdown" [class.open]="dropdownOpen">
            <a class="cursor sh-acc-toggle" (click)="toggleDropdown()">
              <span class="sh-acc-avatar"
                ><i class="fa fa-user-circle-o" aria-hidden="true"></i
              ></span>
              <label class="res-hide"
                >{{ username | titlecase }} <i class="ti ti-chevron-down"></i
              ></label>
            </a>
            <ul
              class="dropdown-menu dropdown-menu-right sh-acc-menu"
              *ngIf="dropdownOpen"
            >
              <li>
                <a [routerLink]="['/dashboard']" class="cursor">My Account</a>
              </li>
              <li>
                <a [routerLink]="['/dashboard/preferences']" class="cursor"
                  >Preferences</a
                >
              </li>
              <li><a (click)="userLogouts()" class="cursor">Logout</a></li>
            </ul>
          </li>
        </ul>

        <ng-template #sh_guestActions>
          <a [routerLink]="['/signin']" class="sh-btn sh-btn-ghost">Log in</a>
          <a [routerLink]="['/signup']" class="sh-btn sh-btn-solid"
            >Sign up <i class="ti ti-arrow-right"></i
          ></a>
        </ng-template>

        <div class="sh-burger" (click)="openMobileNav()">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>
  </header>
</div>

<!-- ===================== MOBILE OFF-CANVAS PANEL ===================== -->
<div
  class="sh-overlay"
  [class.sh-open]="mobileNavOpen"
  (click)="closeMobileNav()"
></div>

<div class="sh-mobile-panel" [class.sh-open]="mobileNavOpen">
  <div class="sh-mobile-head">
    <a [routerLink]="['/']" class="sh-logo" (click)="closeMobileNav()">
      <img
        src="assets/images/logo.png"
        class="sh-logo-img-dark"
        alt="Sehyog Academy"
      />
    </a>
    <div class="sh-mobile-close cursor" (click)="closeMobileNav()">
      <i class="ti ti-x"></i>
    </div>
  </div>

  <div class="sh-mobile-body">
    <a class="sh-mobile-simple" [routerLink]="['/']" (click)="closeMobileNav()"
      >Home</a
    >

    <!-- 11+ accordion (same dynamic columns, flattened) -->
    <div class="sh-macc" [class.sh-open]="activeMobileAccordion === '11plus'">
      <div
        class="sh-macc-head cursor"
        (click)="toggleMobileAccordion('11plus')"
      >
        11+ <i class="ti ti-chevron-down"></i>
      </div>
      <div class="sh-macc-body">
        <ng-container *ngFor="let col of visibleColumns(elevenPlusColumns)">
          <div class="sh-macc-group-title">{{ col.label }}</div>
          <a
            class="sh-macc-link"
            *ngFor="let link of col.links"
            [routerLink]="link.route"
            [href]="link.href"
            (click)="closeMobileNav()"
          >
            <i class="ti" [ngClass]="link.icon"></i>{{ link.title }}
          </a>
        </ng-container>
      </div>
    </div>

    <!-- GCSE accordion -->
    <div class="sh-macc" [class.sh-open]="activeMobileAccordion === 'gcse'">
      <div class="sh-macc-head cursor" (click)="toggleMobileAccordion('gcse')">
        GCSE <i class="ti ti-chevron-down"></i>
      </div>
      <div class="sh-macc-body">
        <ng-container *ngFor="let col of visibleColumns(gcseColumns)">
          <div class="sh-macc-group-title">{{ col.label }}</div>

          <ng-container *ngFor="let link of col.links">

  <!-- Angular internal route -->
  <a
    *ngIf="link.route"
    class="sh-mega-link"
    [routerLink]="link.route"
    (click)="closeMegaMenu()">

    <span class="ic">
      <i class="ti" [ngClass]="link.icon"></i>
    </span>

    <span class="cp">
      <span class="sh-lt">
        <span class="sh-lt-text">{{ link.title }}</span>

        <span
          class="sh-badge"
          [class.hot]="link.badgeHot"
          *ngIf="link.badge">
          {{ link.badge }}
        </span>
      </span>

      <span class="dc" *ngIf="link.desc">
        {{ link.desc }}
      </span>
    </span>

  </a>

  <!-- External URL -->
  <a
    *ngIf="!link.route && link.href"
    class="sh-mega-link"
    [href]="link.href"
    target="_blank"
    rel="noopener noreferrer"
    (click)="closeMegaMenu()">

    <span class="ic">
      <i class="ti" [ngClass]="link.icon"></i>
    </span>

    <span class="cp">
      <span class="sh-lt">
        <span class="sh-lt-text">{{ link.title }}</span>

        <span
          class="sh-badge"
          [class.hot]="link.badgeHot"
          *ngIf="link.badge">
          {{ link.badge }}
        </span>
      </span>

      <span class="dc" *ngIf="link.desc">
        {{ link.desc }}
      </span>
    </span>

  </a>

</ng-container>

        </ng-container>
      </div>
    </div>

    <!-- Tuition accordion (A-Level + Tuition combined) -->
    <div class="sh-macc" [class.sh-open]="activeMobileAccordion === 'tuition'">
      <div
        class="sh-macc-head cursor"
        (click)="toggleMobileAccordion('tuition')"
      >
        Tuition <i class="ti ti-chevron-down"></i>
      </div>
      <div class="sh-macc-body">
        <ng-container *ngFor="let col of visibleColumns(tuitionColumns)">
          <div class="sh-macc-group-title">{{ col.label }}</div>

          <ng-container *ngFor="let link of col.links">
            <!-- Angular internal route -->
            <a
              *ngIf="link.route"
              class="sh-mega-link"
              [routerLink]="link.route"
              (click)="closeMegaMenu()"
            >
              <span class="ic">
                <i class="ti" [ngClass]="link.icon"></i>
              </span>

              <span class="cp">
                <span class="sh-lt">
                  <span class="sh-lt-text">{{ link.title }}</span>

                  <span
                    class="sh-badge"
                    [class.hot]="link.badgeHot"
                    *ngIf="link.badge"
                  >
                    {{ link.badge }}
                  </span>
                </span>

                <span class="dc" *ngIf="link.desc">
                  {{ link.desc }}
                </span>
              </span>
            </a>

            <!-- External URL -->
            <a
              *ngIf="!link.route && link.href"
              class="sh-mega-link"
              [href]="link.href"
              target="_blank"
              rel="noopener noreferrer"
              (click)="closeMegaMenu()"
            >
              <span class="ic">
                <i class="ti" [ngClass]="link.icon"></i>
              </span>

              <span class="cp">
                <span class="sh-lt">
                  <span class="sh-lt-text">{{ link.title }}</span>

                  <span
                    class="sh-badge"
                    [class.hot]="link.badgeHot"
                    *ngIf="link.badge"
                  >
                    {{ link.badge }}
                  </span>
                </span>

                <span class="dc" *ngIf="link.desc">
                  {{ link.desc }}
                </span>
              </span>
            </a>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Uni. Program accordion -->
    <div class="sh-macc" [class.sh-open]="activeMobileAccordion === 'uni'">
      <div class="sh-macc-head cursor" (click)="toggleMobileAccordion('uni')">
        Uni. Program <i class="ti ti-chevron-down"></i>
      </div>
      <div class="sh-macc-body">
        <a
          class="sh-macc-link"
          *ngFor="let link of uniProgramLinks"
          [routerLink]="link.route"
          [href]="link.href"
          (click)="closeMobileNav()"
        >
          <i class="ti" [ngClass]="link.icon"></i>{{ link.title }}
        </a>
      </div>
    </div>

    <a
      class="sh-mobile-simple"
      [routerLink]="['/blogs']"
      (click)="closeMobileNav()"
      >Blogs <i class="ti ti-chevron-right"></i
    ></a>

    <!-- About Us accordion -->
    <div class="sh-macc" [class.sh-open]="activeMobileAccordion === 'about'">
      <div class="sh-macc-head cursor" (click)="toggleMobileAccordion('about')">
        About Us <i class="ti ti-chevron-down"></i>
      </div>
      <div class="sh-macc-body">
        <ng-container *ngFor="let col of visibleColumns(aboutUsColumns)">
          <div class="sh-macc-group-title">{{ col.label }}</div>

          <ng-container *ngFor="let link of col.links">
            <!-- Angular internal route -->
            <a
              *ngIf="link.route"
              class="sh-mega-link"
              [routerLink]="link.route"
              (click)="closeMegaMenu()"
            >
              <span class="ic">
                <i class="ti" [ngClass]="link.icon"></i>
              </span>

              <span class="cp">
                <span class="sh-lt">
                  <span class="sh-lt-text">{{ link.title }}</span>

                  <span
                    class="sh-badge"
                    [class.hot]="link.badgeHot"
                    *ngIf="link.badge"
                  >
                    {{ link.badge }}
                  </span>
                </span>

                <span class="dc" *ngIf="link.desc">
                  {{ link.desc }}
                </span>
              </span>
            </a>

            <!-- External URL -->
            <a
              *ngIf="!link.route && link.href"
              class="sh-mega-link"
              [href]="link.href"
              target="_blank"
              rel="noopener noreferrer"
              (click)="closeMegaMenu()"
            >
              <span class="ic">
                <i class="ti" [ngClass]="link.icon"></i>
              </span>

              <span class="cp">
                <span class="sh-lt">
                  <span class="sh-lt-text">{{ link.title }}</span>

                  <span
                    class="sh-badge"
                    [class.hot]="link.badgeHot"
                    *ngIf="link.badge"
                  >
                    {{ link.badge }}
                  </span>
                </span>

                <span class="dc" *ngIf="link.desc">
                  {{ link.desc }}
                </span>
              </span>
            </a>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <a
      class="sh-mobile-simple"
      [routerLink]="['/contact-us']"
      (click)="closeMobileNav()"
      >Contact Us <i class="ti ti-chevron-right"></i
    ></a>

    <div class="sh-mobile-cta">
      <h5>Book a Free Demo</h5>
      <p>Submit the form to book a free demo.</p>
      <a
        href="https://go.sehyog.co.uk/FreeDemoForm"
        class="sh-btn"
        (click)="closeMobileNav()"
        >Book a Free Demo <i class="ti ti-arrow-right"></i
      ></a>
    </div>
  </div>

  <div class="sh-mobile-foot" *ngIf="!isLoggedInUser">
    <a
      [routerLink]="['/signin']"
      class="sh-btn sh-btn-ghost"
      (click)="closeMobileNav()"
      >Log in</a
    >
    <a
      [routerLink]="['/signup']"
      class="sh-btn sh-btn-solid"
      (click)="closeMobileNav()"
      >Sign up</a
    >
  </div>
  <div class="sh-mobile-foot" *ngIf="isLoggedInUser">
    <a
      [routerLink]="['/dashboard']"
      class="sh-btn sh-btn-ghost"
      (click)="closeMobileNav()"
      >My Account</a
    >
    <a
      (click)="userLogouts(); closeMobileNav()"
      class="sh-btn sh-btn-solid cursor"
      >Logout</a
    >
  </div>
</div>
